export const PromoImage = ({ color, fontFamily, ...rest }) => {
    return (
        <svg
            width="99"
            height="62"
            viewBox="0 0 99 62"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g clipPath="url(#clip0_428_573)">
                <path
                    d="M98.9999 34.145L71.5742 62.0001V30.3262L98.9999 34.145Z"
                    fill={color}
                />
                <path d="M99 0H0V34.1449H99V0Z" fill={color} />
                {/* <path
                    d="M34.9858 22.3552C37.3438 22.3552 38.8018 21.2212 39.7558 19.8172L38.2258 19.0072C37.5958 20.0152 36.4078 20.7532 34.9858 20.7532C32.5558 20.7532 30.6838 18.8272 30.6838 16.1452C30.6838 13.4452 32.5558 11.5372 34.9858 11.5372C36.4078 11.5372 37.5958 12.2752 38.2258 13.2832L39.7558 12.4732C38.8198 11.0692 37.3438 9.93516 34.9858 9.93516C31.5658 9.93516 28.8298 12.4552 28.8298 16.1452C28.8298 19.8352 31.5658 22.3552 34.9858 22.3552ZM45.3665 22.3552C48.0845 22.3552 49.7585 20.3032 49.7585 17.7832C49.7585 15.2812 48.0845 13.2292 45.3665 13.2292C42.6665 13.2292 40.9745 15.2812 40.9745 17.7832C40.9745 20.3032 42.6665 22.3552 45.3665 22.3552ZM45.3665 20.9152C43.6385 20.9152 42.6665 19.4392 42.6665 17.7832C42.6665 16.1452 43.6385 14.6692 45.3665 14.6692C47.1125 14.6692 48.0665 16.1452 48.0665 17.7832C48.0665 19.4392 47.1125 20.9152 45.3665 20.9152ZM58.0073 22.1392H59.6273V10.1332H58.0073V14.7052C57.3053 13.7692 56.2793 13.2292 55.1633 13.2292C52.8953 13.2292 51.2753 15.0112 51.2753 17.8012C51.2753 20.6452 52.8953 22.3552 55.1633 22.3552C56.3153 22.3552 57.3593 21.7612 58.0073 20.8972V22.1392ZM58.0073 19.6552C57.5573 20.3572 56.5853 20.9152 55.5953 20.9152C53.9753 20.9152 52.9673 19.6012 52.9673 17.8012C52.9673 15.9832 53.9753 14.6692 55.5953 14.6692C56.5853 14.6692 57.5573 15.2452 58.0073 15.9472V19.6552ZM61.6816 17.7832C61.6816 20.5192 63.5896 22.3552 66.1816 22.3552C67.5856 22.3552 68.8096 21.9052 69.6736 21.0592L68.9176 19.9972C68.2696 20.6632 67.2616 21.0232 66.3436 21.0232C64.5976 21.0232 63.5176 19.7992 63.3916 18.3232H70.2676V17.9272C70.2676 15.2632 68.6476 13.2292 66.0376 13.2292C63.4996 13.2292 61.6816 15.2632 61.6816 17.7832ZM66.0376 14.5612C67.8736 14.5612 68.6476 16.0012 68.6836 17.1532H63.3736C63.4636 15.9652 64.2916 14.5612 66.0376 14.5612Z"
                    fill="white"
                /> */}
                <text
                    x="20"
                    y="22"
                    fill="white"
                    fontFamily={fontFamily}
                    fontSize={20}
                >
                    Code
                </text>
            </g>
            <defs>
                <clipPath id="clip0_428_573">
                    <rect width="99" height="62" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
